import React from 'react';
import { useParams } from 'react-router-dom';
import displayData from '../fakeData/displayData/displayData';

const BookingDetails = () => {
    const { uniqueId } = useParams();
    const fullInfo = [...displayData];
    return (
        <div>
            
        </div>
    );
};

export default BookingDetails;